<mat-toolbar color="primary" class="embryo-fixed-header">
  <mat-toolbar-row>
    <div class="container">
      <div fxLayoutAlign="space-between">
        <div class="logo-site">
          <img  
            *ngIf="lang == 'en'"
            [src]="environmentVariables?.COLORED_LOGO_EN"
            style="width: 143px; height: 35px; object-fit: cover"
               alt="logo image"
          />
          <img  
            *ngIf="lang == 'ar'"
            [src]="environmentVariables?.COLORED_LOGO_AR"
            style="width: 143px; height: 40px; object-fit: cover"
               alt="logo image"
          />
        </div>
        <embryo-Menu></embryo-Menu>
        <button
          class="responsive-toggle"
          mat-icon-button
          (click)="toggleSidebar()"
        >
          <mat-icon 
          (mouseover)="changeIconFill=false"
          (mouseleave)="changeIconFill=true"
          class="material-icons defulat-icons-color"
          [ngClass]="{
            'material-symbols-outlined': (changeIconFill && environmentVariables?.ENABLE_HEADER_ICONS_FILL === false),
            'icons-fill-color' : (environmentVariables?.HEADER_ICONS_FILL_COLOR)
        }"
          >menu</mat-icon>
        </button>
      </div>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
